export default {
    "realm": "payment",
    "url": window.KEYCLOAK_URL,
    "ssl-required": "all",
    "resource": "payment-service",
    "public-client": true,
    "confidential-port": 0,
    "clientId": 'payment-service',
}

export const keycloackLogoutUrl = '/logout';

export const sessionStorageRedirectParam = 'redirectUrl';